<!-- comment-dialog.component.html -->
<div class="comment-dialog">
    <img [src]="data.postData.imageUrl" alt="Post image" *ngIf="data.postData.imageUrl">
    <p>{{ data.postData.comment }}</p>
    <hr>
    <div *ngFor="let comment of data.postData.comments">
      <p>{{ comment.text }}</p>
    </div>
    <form (ngSubmit)="addComment()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'COMMENT.ADD_COMMENT' | translate }}</mat-label>
        <textarea matInput [formControl]="commentControl" placeholder="{{ 'COMMENT.PLACEHOLDER' | translate }}"></textarea>
        <mat-error *ngIf="commentControl.hasError('required')">
          {{ 'COMMENT.ERROR.REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>
      <div class="dialog-actions">
        <button mat-icon-button type="button">
          <mat-icon>photo_camera</mat-icon>
        </button>
        <button mat-raised-button color="primary" type="submit" [disabled]="!commentControl.valid">
          {{ 'COMMENT.SUBMIT' | translate }}
        </button>
        <button mat-button type="button" (click)="onNoClick()">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
    </form>
</div>